module.exports = __webpack_public_path__ + "static/media/battery.2b462078.svg";